import { useEffect, useState } from "react";
import { Box, Button, Link } from "@mui/material";

import googlePlayBadge from "assets/images/google-play-badge.png";
import Icon from "@mdi/react";
import { mdiWeb } from "@mdi/js";
import { Capacitor } from "@capacitor/core";
import { isAndroid } from "utils/device";
import config from "config";

function InstallApp() {
  const [supportsPWA, setSupportsPWA] = useState<boolean>(false);
  const [promptInstall, setPromptInstall] = useState<any>(null);

  const beforeInstallPrompt = (e: Event) => {
    e.preventDefault();
    setSupportsPWA(true);
    setPromptInstall(e);
  };

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", beforeInstallPrompt);

    return () => window.removeEventListener("beforeinstallprompt", beforeInstallPrompt);
  }, []);

  /**
   * Show chrome install banner
   *
   * @returns
   */
  const handleInstall = async () => {
    if (!promptInstall) {
      return;
    }

    promptInstall.prompt();

    await promptInstall.userChoice;
  };

  return (
    <Box alignItems='center' display='flex' px={1} pt={1} gap={1}>
      {Capacitor.getPlatform() === "web" && isAndroid() ? (
        <Link
          href={config.links.googlePlay}
          rel='noopener noreferrer'
          style={{ WebkitTapHighlightColor: "transparent" }}
          sx={{ "&:hover": { opacity: 0.8 }, "&:focus": { opacity: 0.8 }, display: "flex" }}
          target='_blank'
        >
          <img width={145} src={googlePlayBadge} alt='Google Play' />
        </Link>
      ) : null}
      {supportsPWA ? (
        <Button startIcon={<Icon path={mdiWeb} size={0.8} />} variant='contained' onClick={handleInstall}>
          Install web app
        </Button>
      ) : null}
    </Box>
  );
}

export default InstallApp;
